import SubmitRequestSvg from "./icons/submit-request.svg";
import MailUsSvg from "./icons/mailus.svg";
import ChatSvg from "../icons/chat.svg";
import SubmitRequest from "./cards/submit-request";
import MailUs from "./cards/mail-us";
import ChatUs from "./cards/chat-us";
import SmsUs from "./cards/sms-us";
import smsusSvg from "../icons/SMS_64.png";

export const ContactCards = [
  {
    title: "Submit Request",
    image: SubmitRequestSvg,
    desc: "Submit a request form for any other delivery or pickup questions.",
    link: {
      label: "Submit request",
      href: "/inquiry/contact-us.html",
    },
    id: 1,
    allow: ["guest", "user"],
    Card: SubmitRequest,
  },
  {
    title: "Mail us",
    image: MailUsSvg,
    desc: "",
    link: {
      label: "View Order History",
      href: "/order-account/orders",
    },
    id: 2,
    allow: ["guest", "user"],
    Card: MailUs,
  },
  {
    title: "Call us",
    image: ChatSvg,
    desc: "",
    link: {
      label: "View Order History",
      href: "/order-account/orders",
    },
    id: 3,
    allow: ["guest", "user"],
    Card: ChatUs,
  },
  {
    title: "Text us",
    image: smsusSvg,
    desc: "8am - 5pm PT (Monday-Friday)",
    link: {
      label: "View Order History",
      href: "/order-account/orders",
    },
    id: 4,
    allow: ["guest", "user"],
    Card: SmsUs,
  }
];
